import React from "react";
import { Typography, Box } from "@mui/material";
import { FruitifyContainer } from "../../../shared-components/Containers";
import { FruitifyAssignmentSearch } from "../components/FruitifyAssignmentSearch";
import { withPageTracking } from "../../../services/postHog";

const AssignmentOverviewStudent = () => {
  return (
    <FruitifyContainer>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >
        <Typography variant="h3" fontWeight="bold">
          Assignments
        </Typography>
      </Box>
      <FruitifyAssignmentSearch excludeTitle studentView />
    </FruitifyContainer>
  );
};

export default withPageTracking(AssignmentOverviewStudent, {
  feature: "assignments-overview-student",
});
